import React, { useState, useRef, useEffect } from "react";
import Transition from "../utils/Transition";



function Features() {
  const [tab] = useState(1);

  const tabs = useRef(null);

  const heightFix = () => {
    if (tabs.current.children[tab]) {
      tabs.current.style.height =
        tabs.current.children[tab - 1].offsetHeight + "px";
    }
  };

  useEffect(() => {
    heightFix();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab]);

  return (
    <section className="relative" id="products">
      {/* Section background (needs .relative class on parent and next sibling elements) */}
      <div
        className="absolute inset-0 bg-[#548CCF] pointer-events-none mb-16"
        aria-hidden="true"
      ></div>

      <div className="relative max-w-6xl mx-auto px-4 sm:px-6">
        <div className="pt-12 md:pt-20">
          {/* Section header */}
          <div className="max-w-3xl mx-auto text-center pb-12 md:pb-16">
            <p className="h1 mb-4">Our products will be built in public.</p>
            <p className="text-xl text-gray-600">
              For our first product. We want to validate if any of our ideas are
              good enough. We have created{" "}
              <a
                href="https://votes.hulacorn.com"
                target="_blank"
                rel="noopener noreferrer"
                className="underline decoration-sky-500 font-bold"
                aria-label="Cruip"
              >
                votes.hulacorn.com
              </a>{" "}
              for you to direct us to the best ideas.
            </p>
          </div>

          {/* Section content */}
          <div className="md:grid md:grid-cols-12 md:gap-6">
            {/* Content */}
            <div
              className="max-w-xl md:max-w-none md:w-full mx-auto md:col-span-7 lg:col-span-6 md:mt-6"
              data-aos="fade-right"
            >
              <div className="md:pr-4 lg:pr-12 xl:pr-16 mb-8">
                <h3 className="h3 mb-3">Validation is the key to success</h3>
              </div>
              {/* Tabs buttons */}
              <div className="mb-8 md:mb-0">
                <div className="flex items-center text-lg p-5 rounded border transition duration-300 ease-in-out mb-3 bg-white shadow-md border-gray-200 hover:shadow-lg">
                  <div>
                    <div className="font-bold leading-snug tracking-tight mb-1">
                      Vote for your favorite idea
                    </div>
                    <div className="text-gray-600">
                      We have spent time listing out all the problems we see. We
                      wish to know if any of the ideas are worth building. To do
                      that we want potential customers to vote for their
                      favorite idea.
                    </div>
                  </div>
                </div>
                <div className="flex items-center text-lg p-5 rounded border transition duration-300 ease-in-out mb-3 bg-white shadow-md border-gray-200 hover:shadow-lg">
                  <div>
                    <div className="font-bold leading-snug tracking-tight mb-1">
                      Our data is public
                    </div>
                    <div className="text-gray-600">
                      We have no other data at the moment but we have shared our
                      analytics dashboard so you can track traffic to our site.
                      We use{" "}
                      <a
                        href="https://plausible.io/share/votes.hulacorn.com?auth=hQ-NZL0jj9Nn4q_3IBRnK"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="underline decoration-sky-500 font-bold"
                        aria-label="Cruip"
                      >
                        Plausible.io
                      </a>{" "}
                    </div>
                  </div>
                </div>
                <div className="flex items-center text-lg p-5 rounded border transition duration-300 ease-in-out mb-3 bg-white shadow-md border-gray-200 hover:shadow-lg">
                  <div>
                    <div className="font-bold leading-snug tracking-tight mb-1">
                      Building the product
                    </div>
                    <div className="text-gray-600">
                      We want to spend as much time building product and have
                      everything else get out of our way. That is why we will
                      share our experiences with{" "}
                      <a
                        href="https://serverless-stack.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="underline decoration-sky-500 font-bold"
                        aria-label="Cruip"
                      >
                        Serverless Stack
                      </a>{" "}
                      and their CI tool{" "}
                      <a
                        href="https://seed.run/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="underline decoration-sky-500 font-bold"
                        aria-label="Cruip"
                      >
                        Seed.run
                      </a>{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Tabs items */}
            <div
              className="max-w-xl md:max-w-none md:w-full mx-auto md:col-span-5 lg:col-span-6 mb-8 md:mb-0 md:order-1"
              data-aos="zoom-y-out"
              ref={tabs}
            >
              <div className="relative flex flex-col text-center lg:text-right">
                {/* Item 1 */}
                <Transition
                  show={tab === 1}
                  appear={true}
                  className="w-full"
                  enter="transition ease-in-out duration-700 transform order-first"
                  enterStart="opacity-0 translate-y-16"
                  enterEnd="opacity-100 translate-y-0"
                  leave="transition ease-in-out duration-300 transform absolute"
                  leaveStart="opacity-100 translate-y-0"
                  leaveEnd="opacity-0 -translate-y-16"
                >
                  <div className="relative inline-flex flex-col">
                    <div className="aspect-w-9 aspect-h-10 sm:w-1/5">
                      <iframe
                        title="Plausible analytics"
                        className="rounded-xl"
                        src="https://plausible.io/share/votes.hulacorn.com?auth=hQ-NZL0jj9Nn4q_3IBRnK"
                        width="500"
                        height="610"
                        frameBorder="0"
                        allow="autoplay; fullscreen; picture-in-picture"
                        allowFullScreen
                      ></iframe>
                    </div>
                  </div>
                </Transition>
                {/* Item 2 */}
                <Transition
                  show={tab === 2}
                  appear={true}
                  className="w-full"
                  enter="transition ease-in-out duration-700 transform order-first"
                  enterStart="opacity-0 translate-y-16"
                  enterEnd="opacity-100 translate-y-0"
                  leave="transition ease-in-out duration-300 transform absolute"
                  leaveStart="opacity-100 translate-y-0"
                  leaveEnd="opacity-0 -translate-y-16"
                >
                  <div className="relative inline-flex flex-col">
                   </div>
                </Transition>
                {/* Item 3 */}
                <Transition
                  show={tab === 3}
                  appear={true}
                  className="w-full"
                  enter="transition ease-in-out duration-700 transform order-first"
                  enterStart="opacity-0 translate-y-16"
                  enterEnd="opacity-100 translate-y-0"
                  leave="transition ease-in-out duration-300 transform absolute"
                  leaveStart="opacity-100 translate-y-0"
                  leaveEnd="opacity-0 -translate-y-16"
                >
                  <div className="relative inline-flex flex-col">
                   
                  </div>
                </Transition>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Features;
